'use strict';


module.exports = function (client) {

    client.disco.addFeature('urn:xmpp:reference:0');
};



//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/stanza.io/lib/plugins/references.js
// module id = 629
// module chunks = 2